
import { Model } from 'backbone';
import Immutable from 'immutable';

class DashboardNotificationsModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default DashboardNotificationsModel;
